module.exports = __webpack_public_path__ + "static/media/calories.c9d9b651.png";